// export interface IMemberSearch{
//     userId: string,
//     name: string,
//     title: string,
//     deptName: string,
//     positionName: string,
//     skill: string,
//     skillLevel: string,
//     projectCount: number,
//     availableFlag: boolean,
// }

import React, { useState, useEffect } from "react";
import { Carousel } from "../../../base/Carousel";
import { motion } from 'framer-motion';
import { Card } from "../../../base/Card";
import { Avatar, Badge, Button, Heading, Stack, Text } from "../../../base";
import { useAppSelector } from "../../../../redux/app/hooks";
import { RootState } from "../../../../redux/app/store";
import { IApiResult } from "../../../../libs/models/app/APIResult";

export interface IMemberSearch {
  userId: string,
  empNo: string,
  displayName: string,
  titleName: string,
  deptName: string,
  jobName: string,
  projectCount: number,
  availFlag: boolean,
  skill?: string,
  capabilityLevel: string,
  positionName: string,
  skillCardUrl: string,
}

interface IMemberCardsProps {
  functionResults: IApiResult;
}


export const MemberCards: React.FC<IMemberCardsProps> = ({ functionResults }) => {

  const isDesktop = useAppSelector((state: RootState) => state.app.viewType == 'Desktop');

  const [users, setUsers] = useState<IMemberSearch[]>([]);

  useEffect(() => {
    const results: IMemberSearch[] = [];
    // if(isApiResult(functionResults)){
      if (checkType(functionResults.result)) {
        
        results.push(...functionResults.result);
      }
    // }
   
    setUsers(results);
  }, [functionResults])


  const checkType = (data: unknown): data is IMemberSearch[] => {
    return typeof data == 'object' && data != null && Array.isArray(data) && data.length > 0 && typeof (data as IMemberSearch[])[0].userId === 'string';
  }

  const openLink = (url: string) => {
        // window.open(url);
         window.open(url, 'popupWindow', 'width=1000,height=800,scrollbars=yes');
    }

  const MemberCard =
    users?.map((user, index) => (
      <React.Fragment key={`${index}`}>
        <motion.div
          key={`${index}`}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
          style={{ width: 'inherit' }}
        >
          <Card variant="horiontal">
            <div className="card-contents">
              <Stack className="contents-profile">
                <Avatar size="6" src={`https://gspaceapi.kt.co.kr/upload/profile/${user.userId}.jpg`} label=""></Avatar>
                <div className="name">
                  <div className="available-badge"><Badge size={'large'} accent={user.availFlag ? "primary" : "normal"} >{user.availFlag ? '투입 가능' : '투입 불가'}</Badge></div>
                  <Stack className="">
                    <Heading size="body1">{user.displayName}</Heading>
                    <Text size="caption1">{user.titleName.split('(')[0]}</Text>
                  </Stack>
                </div>

              </Stack>
              <div className="member-detail">
                <ul className="d-description">
                  <li className="department">
                    <Text size="caption1" weight="semibold">본부/부서</Text>
                    <Text className="description" size="label2" weight="regular">{user.positionName.split(' ').length > 2
                      ? <>
                        {user.positionName.split(' ')[1]}<br />
                      </>
                      : <>
                      </>
                    }
                    {user.deptName}
                      </Text>
                  </li>
                  <li className="skill">
                    <Text size="caption1" weight="semibold">직무/역량등급</Text>
                    <Text className="description" size="label2" weight="regular">{user.jobName}/{user.capabilityLevel ? user.capabilityLevel : '없음'}</Text>
                  </li>
                  <li className="count">
                    <Text size="caption1" weight="semibold">프로젝트 건수</Text>
                    <Text className="description" size="label2" weight="regular">{user.projectCount} 건</Text>
                  </li>
                </ul>
              </div>
              <Button variant="primary" onClick={() => {openLink(user.skillCardUrl)}}>
                상세조회
              </Button>
            </div>

          </Card>
        </motion.div>
      </React.Fragment>
    ));


  return (
    users && users.length > 0 && <div className="function-result">
      <div className="result-contents search-result-member">
        <Carousel slides={MemberCard} slidesPerView={isDesktop ? 3 : 1} variant="fill" />
      </div>
    </div>
  )
}